import { assignSetting, getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { IR2BRewardConfig } from "@faire/web-api--source/indigofair/data/IR2BRewardConfig";
import { R2B_REWARD_CONFIG_220725 } from "@faire/web-api--source/indigofair/settings/R2B_REWARD_CONFIG_220725";
var r2BRewardConfigDefault = IR2BRewardConfig.build({
    r2b_activation_amount: IFaireMoney.build({
        amount_cents: 5000,
        currency: "USD"
    }),
    r2b_per_order_amount: IFaireMoney.build({
        amount_cents: 5000,
        currency: "USD"
    }),
    r2b_consolation_amount: IFaireMoney.build({
        amount_cents: 1000,
        currency: "USD"
    }),
    r2b_max_credits: IFaireMoney.build({
        amount_cents: 200000,
        currency: "USD"
    }),
    treatment: "treatment1A"
});
export var getSettingR2BAwardConfiguration = function() {
    return getSettingValueWithoutAssignment(R2B_REWARD_CONFIG_220725, r2BRewardConfigDefault);
};
export var assignSettingR2BAwardConfiguration = function() {
    assignSetting(R2B_REWARD_CONFIG_220725);
};
